
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Paper,
  TextField,
  Tooltip,
  Typography,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Divider,
  SelectChangeEvent,
  Select,
  MenuItem,
} from "@mui/material";
import variables from "../../../assets/styles/variables.module.scss";
import SummaryCard from "../../../Shared-ui/SharedComponents/Cards/SummaryCard";
import AddIcon from "@mui/icons-material/Add";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { SetStateAction, useEffect, useState } from "react";
import OldAgent from "../../../Shared-ui/Types/OldAgent";
import Template from "../../../Shared-ui/Types/Template";
import { Youtube } from "../../../Shared-ui/Types/common";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";
import Confirm from "../../../Shared-ui/Types/Confirm";
import { isYouTubeUrl } from "../../../Shared-ui/utils/Common/Common";
import { useDispatch } from "react-redux";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
//import FormView from "./formView";



interface MyComponentProps {
  knowledgeBase: OldAgent | Template | any;
  setknowledgeBase: React.Dispatch<SetStateAction<OldAgent | Template | any>>;
  getknowledgeBase: () => void;
  updateknowledgeBase: () => void;
}


const SourceYoutube: React.FC<MyComponentProps> = (props) => {
  const youTubeInitial = {
    id: 0,
    name: "",
    videoApikey: "",
    youtubeLink: ""
  }
  const youTubeErrInitial = {
    name: { value: false, error: "" },
    videoApikey: { value: false, error: "" },
    youtubeLink: { value: false, error: "" },
  }
  const [youTubes, setYoutubes] = useState<Youtube[]>([])
  const [youTube, setYoutube] = useState<Youtube>(youTubeInitial)
  const [youTubeErr, setYoutubeErr] = useState(youTubeErrInitial)
  const paginationModel = { page: 0, pageSize: 10 };
  const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({ show: false, });
  const [expanded, setExpanded] = useState<boolean>(false); // Track expanded panel
  const [isEditing, setIsEditing] = useState<boolean>(false); // Track expanded panel
  const dispatch = useDispatch()

  useEffect(() => {
    setYoutubes(props.knowledgeBase?.youtube || [])
  }, [props.knowledgeBase])

  const handleCancel = () => {
    setExpanded(false); // Reset expanded state
    setYoutube(youTubeInitial)
    setIsEditing(false)
  };

  const handleCreate = () => {
    setExpanded(true); // Reset expanded state
    setYoutube(youTubeInitial)
    setIsEditing(false)
  };

  const handleSave = (youtubeId?: number) => {
    if (!validateYouTube()) return;

    if (youtubeId === null || youtubeId === undefined) {
      props.setknowledgeBase((preVal: OldAgent) => {
        const existingYoutube = preVal.youtube || []
        youTube.id = existingYoutube[existingYoutube?.length - 1] && existingYoutube[existingYoutube?.length - 1].id >=0 ? existingYoutube[existingYoutube?.length - 1].id + 1 : 0
        const updatedYT = [youTube, ...existingYoutube]
        preVal.youtube = updatedYT
        return preVal
      })
    }
    else {
      props.setknowledgeBase((preVal: OldAgent) => {
        const existingYoutube = preVal.youtube || []
        existingYoutube[youtubeId].name = youTube.name
        existingYoutube[youtubeId].videoApikey = youTube.videoApikey
        existingYoutube[youtubeId].youtubeLink = youTube.youtubeLink
        preVal.youtube = existingYoutube
        return preVal
      })
    }
    setYoutube(youTubeInitial)
    setExpanded(false)
    props.updateknowledgeBase()
  };

  const validateYouTube = () => {
    let ErrCount = 0
    if (!youTube.name?.trim()) {
      setYoutubeErr((preVal) => ({ ...preVal, name: { error: "Please enter the name", value: true } }))
      ErrCount += 1
    } else {
      setYoutubeErr((preVal) => ({ ...preVal, name: { error: "", value: false } }))
    }

    if (!youTube.youtubeLink?.trim()) {
      setYoutubeErr((preVal) => ({ ...preVal, youtubeLink: { error: "Please enter the youtube link", value: true } }))
      ErrCount += 1
    } else if (!isYouTubeUrl(youTube.youtubeLink)) {
      setYoutubeErr((preVal) => ({ ...preVal, youtubeLink: { error: "Please enter the valid youtube link", value: true } }))
      ErrCount += 1
    }
    else {
      setYoutubeErr((preVal) => ({ ...preVal, youtubeLink: { error: "", value: false } }))
    }

    if (!youTube.videoApikey?.trim()) {
      setYoutubeErr((preVal) => ({ ...preVal, videoApikey: { error: "Please enter the api key", value: true } }))
      ErrCount += 1
    } else {
      setYoutubeErr((preVal) => ({ ...preVal, videoApikey: { error: "", value: false } }))
    }

    if (youTubes.some((item: Youtube) => item.youtubeLink === youTube.youtubeLink) && !isEditing) {
      dispatch(ShowError("Link  already exist"))
      ErrCount += 1
    }
    return ErrCount === 0 ? true : false
  }

  const handleEdit = (youtubeId: number) => {
    const youTube = youTubes?.filter((faq: Youtube) => faq.id === youtubeId)[0]
    setYoutube(youTube)
    setExpanded(true)
    setIsEditing(true)
  }

  const handleDelete = (youtubeId: number) => {
    setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
    props.setknowledgeBase((preVal: OldAgent) => {
      const existingYT= preVal.youtube || []
      const updatedYT = existingYT?.filter((faq: Youtube) => faq.id !== youtubeId)
      preVal.youtube = updatedYT
      return preVal
    })
    props.updateknowledgeBase()
  }

  const deleteConfirm = (row: number) => {
    setConfirmPopupData({
      show: true,
      setConfirmPopupData: setConfirmPopupData,
      title: "Confirm Delete",
      info: "Are you sure want to delete your data? This action cannot be undone.",
      varient: "delete",
      functionName: handleDelete,
      functionParam: row,
    });
  };


  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target
    setYoutube(preVal => ({ ...preVal, [name]: value }))
  }

  const columns: GridColDef[] = [
    // { field: "id", headerName: "ID", width: 70 },
    { field: "name", headerName: "Name", width: 180 },
    { field: "youtubeLink", headerName: "Youtube Link", width: 250 },
    { field: "videoApikey", headerName: "Video API key", width: 250 },

    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => {
        const handleEditClick = (event: React.MouseEvent) => {
          event.stopPropagation(); // Prevent row selection
          handleEdit(params.row.id)
        };

        const handleDeleteClick = (event: React.MouseEvent) => {
          event.stopPropagation(); // Prevent row selection
          deleteConfirm(params.row.id)
        };

        return (
          <Box>
            <IconButton aria-label="edit" onClick={handleEditClick}>
              <EditOutlinedIcon />
            </IconButton>
            <IconButton aria-label="delete" onClick={handleDeleteClick}>
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Box>
        );
      },
    },
  ];



  return (
    <Box
      sx={{
        width: "100%",
        display: "block",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          ml: -2,
          mr: -2,
        }}
      >
        {/* Left Content */}
        <Box
          sx={{
            width: {
              lg: "calc(100% - 300px)",
              md: "calc(100% - 300px)",
              sm: "100%",
            },
            flex: "0 0 auto",
            boxSizing: "border-box",
            minWidth: {
              lg: "calc(100% - 300px)",
              md: "calc(100% - 300px)",
              sm: "100%",
            },
            pl: 2,
            pr: 2,
            maxWidth: "100%",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Youtube
            </Typography>
            <Box>
              <Tooltip title="Add Youtube" placement="top">
                <IconButton
                  color="secondary"
                  aria-label="add icon"
                  sx={{ color: variables.primaryColor }}
                  onClick={() => {
                    handleCreate()
                  }}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          {expanded && (
            <Box
              sx={{
                "&::before": {
                  content: '""',
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 7,
                },
              }}
            >
              <Box
                sx={{
                  width: "500px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                  pt: "10px",
                  position: "fixed",
                  right: "0",
                  top: "0",
                  height: "100vh",
                  background: variables.whiteColor,
                  padding: "20px 30px",
                  zIndex: 8,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    height: "100%",
                  }}
                >
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography variant="h6" gutterBottom>
                        New Youtube
                      </Typography>
                      <IconButton aria-label="close" onClick={handleCancel}>
                        <CloseIcon />
                      </IconButton>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 3,
                        mt: 2,
                        pt: "5px",
                        height: "calc(100vh - 160px)",
                        overflow: "auto",
                      }}
                    >
                      <FormControl fullWidth variant="outlined" required error={youTubeErr.name.value}>
                        <InputLabel
                          htmlFor="name"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Name
                        </InputLabel>
                        <TextField
                          //size="small"
                          id="name"
                          name="name"
                          error={youTubeErr.name.value}
                          helperText={youTubeErr.name.error}
                          value={youTube.name}
                          onChange={handleChange}
                          placeholder="Enter the name"
                          sx={{ background: "white" }}
                        />
                      </FormControl>


                      <FormControl fullWidth variant="outlined" required error={youTubeErr.youtubeLink.value}>
                        <InputLabel
                          htmlFor="youtubeLink"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Youtube Link
                        </InputLabel>
                        <TextField
                          // size="small"
                          id="youtubeLink"
                          name="youtubeLink"
                          placeholder="Enter Youtube Link"
                          sx={{ background: "white" }}
                          onChange={handleChange}
                          error={youTubeErr.youtubeLink.value}
                          helperText={youTubeErr.youtubeLink.error}
                          value={youTube.youtubeLink}
                        />
                      </FormControl>
                      <FormControl fullWidth variant="outlined" required error={youTubeErr.videoApikey.value}>
                        <InputLabel
                          htmlFor="videoApikey"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Video API key
                        </InputLabel>
                        <TextField
                          // size="small"
                          id="folderPath"
                          name="videoApikey"
                          placeholder="Enter Video API key"
                          onChange={handleChange}
                          error={youTubeErr.videoApikey.value}
                          helperText={youTubeErr.videoApikey.error}
                          value={youTube.videoApikey}
                          sx={{ background: "white" }}
                        />
                      </FormControl>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      gap: 2,
                      justifyContent: "flex-end",
                      position: "absolute",
                      bottom: 0,
                    }}
                  >
                    <Button
                      fullWidth
                      variant="outlined"
                      disableElevation
                      size="large"
                      sx={{
                        textTransform: "capitalize",
                      }}
                      onClick={handleCancel} // Call handleCancel on click
                    >
                      Cancel
                    </Button>
                    <Button
                      fullWidth
                      variant="contained"
                      disableElevation
                      size="large"
                      sx={{
                        textTransform: "capitalize",
                      }}
                      onClick={() => handleSave(isEditing ? youTube.id : undefined)}
                    >
                      Save
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}


          <Paper sx={{ height: 400, width: "100%", mt: "20px" }} elevation={0}>
            <DataGrid
              rows={youTubes}
              columns={columns}
              // initialState={{ pagination: { paginationModel } }}
              pageSizeOptions={[10]}
              paginationMode="client"
              pagination={true}
              sx={{
                border: 1,
                borderColor: variables.borderColor,
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "& .MuiDataGrid-cell:focus-within": {
                  outline: "none",
                },
              }}
            />
          </Paper>
        </Box>



        {/* Right Summary Card */}
        <Box
          sx={{
            width: { lg: "300px", md: "300px", sm: "100%" },
            minWidth: { lg: "300px", md: "300px", sm: "100%" },
            boxSizing: "border-box",
            flex: "0 0 auto",
            pl: 2,
            pr: 2,
            mt: { lg: "0", md: "0", sm: "30px" },
          }}
        >
          <SummaryCard />
        </Box>
      </Box>
      <ConfirmPopup details={confirmPopupData} />
    </Box>
  );
};

export default SourceYoutube;
